import { AirlineLiteModel, AirlineModel } from 'api-hooks/airline';
import { GuestLiteModel, GuestModel } from 'api-hooks/guest';
import { PreferenceTagItemModel } from 'api-hooks/preference-tag';
import { Expose, Type } from 'class-transformer';
import { FlightCheckInStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { CommonMutationInput, SaleLiteModel, SaleModel } from '../common';

// Model

export class TicketSaleGuestItemModel {
  id: string;
  ticket: string;
  preferences: { id: string; name: string }[];

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class TicketSaleAirlineItemModel {
  id: string;
  detail: string;
  route: string;
  time: string;

  @Type(() => Date)
  date: Date;

  @Type(() => AirlineLiteModel)
  airline: AirlineLiteModel;

  @Type(() => PreferenceTagItemModel)
  preference?: PreferenceTagItemModel;

  @Type(() => Number)
  price: number;
}

export class TicketSaleAddOnsItemModel {
  id: string;
  route: string;
  description?: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class TicketSalePreferenceItemModel {
  id: string;
  detail: string;

  @Expose({ name: 'guest_id' })
  guestId: string;

  @Expose({ name: 'airline_id' })
  airlineId: string;

  @Expose({ name: 'booking_preferences' })
  bookingPreferences: { id: string; label: string }[];
}

export class TicketSaleFlightSaleItemModel extends CommonModel {
  @Expose({ name: 'reschedule_fee' })
  @Type(() => Number)
  rescheduleFee?: number | null;

  @Expose({ name: 'flight_sale_guests' })
  @Type(() => TicketSaleGuestItemModel)
  flightSaleGuests: TicketSaleGuestItemModel[];

  @Expose({ name: 'flight_sale_airlines' })
  @Type(() => TicketSaleAirlineItemModel)
  flightSaleAirlines: TicketSaleAirlineItemModel[];

  @Expose({ name: 'flight_sale_add_ons' })
  @Type(() => TicketSaleAddOnsItemModel)
  flightSaleAddOns: TicketSaleAddOnsItemModel[];

  @Expose({ name: 'booking_code' })
  bookingCode?: string | null;
}

export class TicketSaleLiteModel extends SaleLiteModel {
  @Expose({ name: 'is_open_ticket' })
  @Type(() => Boolean)
  isOpenTicket: boolean;
}

export class FlightSaleGuestDetailModel {
  id: string;
  status: string;
  ticket: string;
  time: string;
  route: string;
  detail: string;

  @Type(() => PreferenceTagItemModel)
  preference: PreferenceTagItemModel | null;

  @Type(() => PreferenceTagItemModel)
  preferences: PreferenceTagItemModel[];

  @Type(() => Number)
  price: number;

  @Type(() => GuestModel)
  guest: GuestModel;

  @Type(() => Date)
  date: Date;

  @Type(() => AirlineModel)
  airline: AirlineModel;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt: Date;

  @Expose({ name: 'check_in_status' })
  checkInStatus: FlightCheckInStatusEnum | null;
}
export class FlightSaleDetailModel {
  id: string;

  @Expose({ name: 'booking_code' })
  bookingCode: string | null;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt: Date;

  @Expose({ name: 'flight_sale_guests' })
  @Type(() => FlightSaleGuestDetailModel)
  flightSaleGuests: FlightSaleGuestDetailModel[];

  @Expose({ name: 'flight_sale_add_ons' })
  @Type(() => TicketSaleAddOnsItemModel)
  flightSaleAddOns: TicketSaleAddOnsItemModel[];
}

export class TicketSaleModel extends SaleModel {
  @Expose({ name: 'flight_sales' })
  @Type(() => FlightSaleDetailModel)
  flightSales: FlightSaleDetailModel[];

  @Type(() => TicketSalePreferenceItemModel)
  preferences: TicketSalePreferenceItemModel[];

  @Expose({ name: 'ticket_description' })
  ticketDescription?: string;

  @Expose({ name: 'is_open_ticket' })
  @Type(() => Boolean)
  isOpenTicket?: boolean;
}

// Input

export class getTicketSalesInput {
  params: CommonParamInput & {
    selection?: string;
  };
}

export class getTicketSaleInput {
  id: string;
}

// export class TicketSaleGuestItemInput {
//   id?: string | null;
//   guestId: string | null;
//   ticket?: string | null;
//   preferences?: { id: string; label: string }[];
// }

// export class TicketSaleAirlineItemInput {
//   id?: string | null;
//   airlineId: string | null;
//   date: Date | null;
//   detail: string;
//   preferenceId?: string | null;
//   route: string;
//   time: string;
//   price: number;
// }

// export class TicketSaleAddOnsItemInput {
//   id?: string | null;
//   guestId?: string | null;
//   route: string;
//   description: string;
//   price: number;
// }

// export class TicketSaleScheduleItemInput {
//   id?: string | null;
//   bookingCode?: string | null;
//   flightSaleGuests: TicketSaleGuestItemInput[];
//   flightSaleAirlines: TicketSaleAirlineItemInput[];
//   flightSaleAddOns: TicketSaleAddOnsItemInput[];
// }

export class TicketSaleFlightSaleGuestMutationInput {
  id?: string;
  ticket: string;
  preferences: string[];
  guestId: string;
}

export class TicketSaleFlightSaleAirlineMutationInput {
  id?: string;
  airlineId: string;
  date: Date;
  detail: string;
  preferenceId: string;
  route: string;
  time: string;
  price: number;
}

export class TicketSaleFlightSaleAddOnsMutationInput {
  id?: string;
  guestId: string;
  price: number;
  route: string;
}

export class TicketSaleFlightSaleMutationInput {
  id?: string;
  bookingCode: string;
  flightSaleGuests: TicketSaleFlightSaleGuestMutationInput[];
  flightSaleAirlines: TicketSaleFlightSaleAirlineMutationInput[];
  flightSaleAddOns: TicketSaleFlightSaleAddOnsMutationInput[];
}
export class TicketSaleMutationInput extends CommonMutationInput {
  flightSales: TicketSaleFlightSaleMutationInput[];
}

export class FlightSaleRescheduleItemInput extends TicketSaleFlightSaleMutationInput {
  rescheduleFee: number;
}

export class FlightSaleRescheduleMutationInput {
  transactionAt: Date | null;
  total: number;
  flightSales: {
    id: string;
    bookingCode?: string | null;
    flightSaleGuests: {
      ticket: string;
      preferences: string[];
      airlineId: string;
      date: Date;
      detail: string;
      preferenceId?: string;
      route: string;
      time: string;
      price: number;
      id: string;
      guestId: string;
      checkInStatus: string | null;
    }[];
    flightSaleAddOns: {
      description?: string;
      price: number;
      id: string;
      guestId: string;
      route: string;
    }[];
  }[];
}

export class FlightSaleReschedulePutInput {
  flightSaleId: string;
  body: FlightSaleRescheduleMutationInput;
}

export class OpenTicketSaleMutationInput {
  isOpenTicket: boolean;
  lastReissueDate?: Date | null;
  lastTravellingDate?: Date | null;
  ticketDescription?: string;
}

export class TicketSaleUpdateInput {
  ticketSaleId: string;
  body: TicketSaleMutationInput;
}

export class TicketSaleDeleteInput {
  id: string;
}

export class OpenTicketPatchInput {
  flightSaleRefId: string;
  body: OpenTicketSaleMutationInput;
}
